import { render, staticRenderFns } from "./IconIosAddToHome.vue?vue&type=template&id=1fbcf7fe&scoped=true"
import script from "./IconIosAddToHome.vue?vue&type=script&lang=js"
export * from "./IconIosAddToHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbcf7fe",
  null
  
)

export default component.exports